"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationListSelectedFilters = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const lodash_es_1 = require("lodash-es");
const useNotificationListState_1 = require("../hooks/useNotificationListState");
const translations_1 = require("../types/translations");
const NotificationListFilters_1 = require("./NotificationListFilters");
const trackingIds = {
    chip: 'notification_list-selected_filters-filter',
    resetFilters: 'notification_list-selected_filters-reset_button',
};
exports.testIds = {
    filterChip: 'notification_list-selected_filters-filter',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    selectedFilters: {
        background: theme.palette.background.default,
    },
    resetButton: {
        padding: theme.spacing(0.62, 1.75),
    },
    chip: {
        margin: theme.spacing(0.5, 1, 0.5, 0),
    },
}));
const NotificationListSelectedFilters = () => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { typeFilter, setTypeFilter, statusFilter, setStatusFilter, durationFilter, setDurationFilter, setStartDateFilter, setEndDateFilter, resetFilters, } = (0, useNotificationListState_1.useNotificationListState)();
    const filteredTypeFilterList = typeFilter.filter((filter) => !(0, lodash_es_1.includes)(NotificationListFilters_1.defaultQuickFilters, filter));
    if (!filteredTypeFilterList.length && !statusFilter.length && !durationFilter?.length) {
        return null;
    }
    const removeFilterFromList = (filter, list) => list.filter((listItem) => listItem !== filter);
    const getTagChip = (filter, onDelete) => {
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Tag, { color: "info", label: translate((0, translations_1.getNotificationFilterTranslation)(filter)), onDelete: () => onDelete(filter), className: classes.chip, "data-testid": exports.testIds.filterChip, "data-tracking-id": trackingIds.chip }, filter));
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { px: 3, py: 2, className: classes.selectedFilters, children: [filteredTypeFilterList.map((filter) => getTagChip(filter, (targetFilter) => {
                setTypeFilter(removeFilterFromList(targetFilter, typeFilter));
            })), statusFilter.map((filter) => getTagChip(filter, (targetFilter) => {
                setStatusFilter(removeFilterFromList(targetFilter, statusFilter));
            })), durationFilter &&
                getTagChip(durationFilter, () => {
                    setStartDateFilter(null);
                    setEndDateFilter(null);
                    setDurationFilter(null);
                }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { size: "small", className: classes.resetButton, "data-tracking-id": trackingIds.resetFilters, onClick: resetFilters, children: translate(translations_1.notificationListFilterTranslations.resetButton) })] }));
};
exports.NotificationListSelectedFilters = NotificationListSelectedFilters;
//# sourceMappingURL=NotificationListSelectedFilters.js.map